var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tooltip',{attrs:{"content":_vm.$t(this.content),"placement":_vm.placement,"disabled":_vm.disabled || _vm.hasPermissions,"enterable":false}},[_c('div',{class:[_vm.disabled || _vm.hasPermissions ? 'cursor' : 'not-allowed']},[_vm._t("main-content",null,{"hasPermissions":_vm.hasPermissions})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }